import React, { useEffect, useState } from "react";
import SummaryRow from "./SummaryRow";
import { usePaymentCalculations } from "./usePaymentCalculations";
import { PaymentSummaryContentProps } from "./types";

const PaymentSummaryContent: React.FC<PaymentSummaryContentProps> = ({ selectedProducts, paymentMethod, customerName, discount, tipsAmount, receivedAmount, onReceivedAmountChange, time }) => {
  const { subtotal, tipsTotal, discountValue, total, remainingAmount } = usePaymentCalculations({
    selectedProducts,
    discount,
    tipsAmount,
    receivedAmount,
  });

  const [localAmount, setLocalAmount] = useState(receivedAmount === "0" ? "" : receivedAmount);

  useEffect(() => {
    setLocalAmount(receivedAmount === "0" ? "" : receivedAmount);
  }, [receivedAmount]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "-" || e.key === "e" || e.key === "+") e.preventDefault();
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData.getData("Text");
    if (parseFloat(pasted) < 0) e.preventDefault();
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.target.value.replace(/-/g, "");

    if (/^\d*\.?\d*$/.test(val)) {
      if (val.startsWith("0") && val.length > 1 && !val.startsWith("0.")) {
        val = val.replace(/^0+/, "");
      }

      setLocalAmount(val);
      const numVal = parseFloat(val || "0");

      if (numVal > total) {
        onReceivedAmountChange(total.toFixed(2));
        setLocalAmount(total.toFixed(2));
      } else {
        onReceivedAmountChange(val === "" ? "0" : val);
      }
    }
  };

  const handleBlur = () => {
    if (localAmount === "") {
      setLocalAmount("0");
      onReceivedAmountChange("0");
    }
  };

  return (
    <div className="px-1 py-1 space-y-2">
      <SummaryRow label="Customer Name" value={customerName || "N/A"} />
      <SummaryRow label="Order Date" value={`${time.year}-${time.month}-${time.day}`} />
      <SummaryRow label="Order Time" value={`${time.hours}:${time.minutes}`} />

      <hr className="my-3" />

      <SummaryRow label="Subtotal" value={`${subtotal.toFixed(2)} QAR`} />
      <SummaryRow label="Discount" value={`${discountValue.toFixed(2)} QAR`} />

      {tipsTotal > 0 && <SummaryRow label="Tips" value={`${tipsTotal.toFixed(2)} QAR`} />}

      <SummaryRow label="Payment Method" value={paymentMethod} highlight />

      <hr className="my-3" />

      <SummaryRow label="Total Amount" value={`${total.toFixed(2)} QAR`} highlight />

      {paymentMethod === "cash" && (
        <>
          <div className="flex justify-between items-center py-2">
            <span className="text-gray-700">Received Amount</span>
            <input
              type="number"
              value={localAmount}
              onChange={handleInputChange}
              onFocus={() => {
                if (localAmount === "0") setLocalAmount("");
              }}
              onBlur={handleBlur}
              onKeyDown={handleKeyDown}
              onPaste={handlePaste}
              // className="w-28 border border-gray-300 rounded px-2 py-1 text-sm focus:ring-2 focus:ring-blue-500"
              className="w-[100px] h-9 text-left text-gray-800 placeholder:text-gray-700 border border-gray-400 rounded-md px-2 py-1"
              min={0}
              max={total}
              style={{ textAlign: "right" }}
              placeholder="0"
            />
          </div>

          <SummaryRow label="Remaining Amount" value={`${remainingAmount.toFixed(2)} QAR`} />
        </>
      )}
    </div>
  );
};

export default PaymentSummaryContent;
